import React, { useState, useEffect, JSX } from 'react'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { APIGetLoggersModel, BuildApiGetLoggers } from '../../models/APIGetLoggersModel'
import { Chip, useTheme, Menu, MenuItem, Button } from '@mui/material';
import { isLCLLogger } from 'variables/chariotProductIds';
import { Redirect } from "react-router-dom";
import Loader from '../../Utils/Loader/NewLoader2025'
import { useTabletContext, useMobileLandscape } from '../../Context/ContextProvider'


interface RedirectProps {
    serial: number | undefined;
}

interface DeviceData {
    company: string;
    id: number;
    lastConnected: Date;
    latestBattery: number; 
    model: string;
    serial: number;
    siteName: string;
    siteNameUserFriendly: string;
}



const LowBatteryMobile: React.FC = () => {
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    const intl: IntlShape = useIntl()
    const theme = useTheme()


    const [loading, setLoading] = useState<boolean>(true)
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps | null>()
    const [devices, setDevices] = useState<Array<DeviceData>>()

    const reloadData = () => {
        CallGetAPI(CreateUrl('/api/Dashboard/lowbattery?companyid=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId')), {})
            .then(data => {
                setDevices(data)
                setLoading(false)
            })
            .catch(err => {
                console.error(err)
                setDevices([])
                setLoading(false)
            })
    }

    useEffect(() => {
        reloadData()
    }, [])


    const renderOverviewButton = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {

        return (!isTablet && !isLandscape ?
            <Button color="secondary" variant="contained" onClick={(): void => deviceOverviewClick(data.data.serial, data.data.model)}><FormattedMessage id='Overview' /></Button> : 
            <div style={{display: "flex", justifyContent: "center"} }>
                <Button color="secondary" variant="contained" onClick={(): void => deviceOverviewClick(data.data.serial, data.data.model)}><FormattedMessage id='Overview' /></Button>
            </div>)
    }

    const deviceOverviewClick = (serial: number | undefined, model: string | undefined): void => {
        console.log(serial, model)
        setRedirect(true)
        setRedirectPath(!isLCLLogger(model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({ serial: serial })
    }

    const serialColumnTemplate = (item: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        console.log(item)

        return (<Chip
            label={item.data.serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={(): void => deviceOverviewClick(item.data.Serial, item.data.Model)}
        //onContextMenu={(e): void => handleContextMenu(e, item.data.serial, item.data.model)}
        />)
    }


    return (<>
    {loading ? <div style={{
        position: 'relative', left: 'Calc(50% - 100px)', minHeight: 200
    }}>
        <Loader color={undefined} />
    </div> :
        !redirect ? (<div>
            <Card>
                <CardHeader color="primary">
                        <h4 style={{ textAlign: "center" }}>{intl.formatMessage({ id: 'Devices where Battery voltage has been less than or equal to 3.3v, 4 times in the last 24 hours' })}</h4>
                </CardHeader>
                <CardBody>
                        {console.log(devices) }
                    <DataGrid
                        dataSource={devices}
                        scrolling={{
                            mode: 'standard',
                            useNative: false
                        }}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                    >
                        <FilterRow visible={true} />
                        <HeaderFilter visible={true} search={{ enabled:  true}} />
                        <Column dataField="Serial" dataType="string" cellRender={(data): JSX.Element => serialColumnTemplate(data)} caption={intl.formatMessage({ id: "Serial" })} width={77} />
                            {isTablet && <Column dataField="siteName" caption={intl.formatMessage({ id: "Site Ref" })} />}
                        {isTablet && <Column dataField="siteNameUserFriendly" caption={intl.formatMessage({ id: "Site Name" })} />}
                            <Column
                                dataField="timestamp"
                                customizeText={(cellInfo) => {
                                    return moment(cellInfo.value).format("DD MMM HH:mm");
                                }}
                                caption={intl.formatMessage({ id: 'Last Low Battery' })}
                                allowHeaderFiltering={true}
                                format="datetime"
                            />
                            
                        <Column cellRender={(data): JSX.Element => renderOverviewButton(data)} caption={intl.formatMessage({ id: "Details" })} />
                    </DataGrid>
                </CardBody>
            </Card>
        </div>) :
            <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />}
    </>)
}
export default LowBatteryMobile